import classNames from "classnames";
import React from "react";
import { observer } from "mobx-react";
import { Tick } from "../../../icons";

export interface IDropdownItemProps {
  name: string;
  onSelect: () => void;
  selected?: boolean;
  disable?: boolean;
}

@observer
export default class DropdownItem extends React.Component<IDropdownItemProps> {
  public render() {
    const { name, selected, onSelect, disable } = this.props;
    return (
      <div
        className={classNames({
          "dropdown-item": true,
          "space-between": true,
          "dropdown-item--disable": disable,
        })}
        onClick={onSelect}
      >
        <span
          className={classNames({
            "dropdown-item__name": true,
            "dropdown-item__name--disable": disable,
          })}
        >
          {name}
        </span>
        {selected && (
          <Tick
            className={classNames({
              "dropdown-item__tick": true,
              "dropdown-item__tick--disable": disable,
            })}
          />
        )}
      </div>
    );
  }
}
